import { imgInstruction } from "../assets/imgIntruction";

export const imagesIntroTema1 = {
	T1_subtema1: [
		{
			text: `Toca encima de las secciones para conocer detalles.`,
			images: imgInstruction.sub1act2_01,
			act: 2,
		},
		{
			text: `Toca encima de los objetos para obtener información.`,
			images: imgInstruction.sub1act2_03,
			act: 2,
		},
		{
			text: `Toca encima de las tiendas Oxxo para obtener información.`,
			images: imgInstruction.sub1_act_3_001,
			act: 3,
		},
		{
			text: `Toca encima de el piso para trasladarte al área seleccionada.`,
			images: imgInstruction.sub1_act_3_01,
			act: 4,
		},
		{
			text: `Toca y arrastra con tu dedo para girar la vista.`,
			images: imgInstruction.sub1_act_3_02,
			act: 4,
		},
	],
	T1_subtema2: [
		{
			text: `Pellizca la pantalla para acercar o alejar la vista.`,
			images: imgInstruction.sub2act1_02,
			act: 1,
		},
		{
			text: `Toca encima de los objetos para removerlos del piso.`,
			images: imgInstruction.sub2act1_03,
			act: 1,
		},
		{
			text: `Toca encima del producto
			que desees acomodar, después...`,
			images: imgInstruction.sub2_act_2_01,
			act: 2,
		},
		{
			text: `Toca  encima del lugar en el anaquel 
			donde deseas acomodarla`,
			images: imgInstruction.sub2_act_2_02,
			act: 2,
		},
	],
	T1_subtema3: [
		{
			text: `Toca encima de el producto que desees acomodar, después...`,
			images: imgInstruction.sub3_act_1_01,
			act: 2,
		},
		{
			text: `...Toca encima de el lugar en el anaquel donde deseas acomodarla.`,
			images: imgInstruction.sub3_act_1_02,
			act: 2,
		},
	],
	T1_subtema4: [
		{
			text: `Toca encima de la etiqueta en mal estado para cambiarla.`,
			images: imgInstruction.sub4_act_1_01,
			act: 1,
		},
	],
	T1_subtema5: [

	],
	T1_subtema6: [

	],
	T1_subtema7: [

	],
}